export default __webpack_public_path__ + "static/coarserwaxdust-cadeaeddd83434fa85c0c07493695acf.png";